// extracted by mini-css-extract-plugin
export var container = "_af-0";
export var error = "_af-9";
export var label = "_af-5";
export var light = "_af-6";
export var md = "_af-3";
export var sm = "_af-2";
export var thin = "_af-8";
export var thinBold = "_af-7";
export var vertical = "_af-4";
export var xs = "_af-1";